export const leadFormInitialValues = {
	buildingNotFound: false,
	clientNotFound: false,
	building: null,
	address: '',
	zip: '',
	city: '',
	clientId: '',
	clientFirstName: '',
	clientLastName: '',
	phone: '',
	products: [],
	comment: '',
	type: 'socialMediaLead',
	marketingAuthorization: null,
	marketingChannelId: null,
	marketingCategoryId: null,
	marketingCustomerTypeId: null,
	marketingSourceId: null,
	handlerId: null,
	handlerComment: '',
};

export const salespersonsQuery = {
	_limit: 999,
	roleTypes: 'salesmanager,salesman',
	include: 'organizations',
};

export const leadCalendarResourceIncludes = [
	'team',
	'salesmanVisit',
	'salesmanVisit.products',
	'salesmanVisit.user',
	'organization',
];

const leadCalendarResourceIncludeStr = leadCalendarResourceIncludes
	.map(x => `calendarResource.${x}`)
	.join(',');

export const leadInclude = `user,building,client,building.clients,handler.organizations,marketingChannel,marketingSource,marketingCustomerType,marketingCategory,products,tags,${leadCalendarResourceIncludeStr}`;
